import React from 'react';


// @mui/icons-material

import Info from "@mui/icons-material/Info";
import ListAlt from "@mui/icons-material/ListAlt";
import Beenhere from "@mui/icons-material/Beenhere";
import Receipt from "@mui/icons-material/Receipt";
import AddCircle from "@mui/icons-material/AddCircleOutline";
import RemoveCircle from "@mui/icons-material/RemoveCircleOutline";

import Button from '../components/Button.jsx';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import OthelloWaiting from '../componentsothello/OthelloWaiting.jsx';
import OthelloTimer from '../componentsothello/OthelloTimer';
import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';
import OthelloCard from '../componentsothello/OthelloCard.jsx';
import OthelloTitulo from '../componentsothello/OthelloTitulo.jsx';

import { TiposBusquedaEstadisticas, TiposPreguntaEncuenta, TipoPreguntaEncuenta, OpcionSiNoEncuesta, OpcionComboBienMalRegularEncuesta, OpcionComboUnoDiezEncuesta, OpcionEstrellasEncuesta } from "../othelloConstantes.jsx";



import { TipoBusquedaEstadisticas } from '../othelloConstantes.jsx';

import nacionalidades from "../assets/nacionalidades.json";
import OthelloTituloPanelData from '../componentsothello/OthelloTituloPanelData.jsx';

export default function EncuestasEstadisticaFiltradas({ ...props }) {

    //Gestion de filtros
    const [loadingFiltros, setLoadingFiltros] = React.useState(true);
    const [filtros, setFiltros] = React.useState("");

    //Gestion de la lista de entregas traspasos
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState(null);    

    const [resultadosFiltros, setResultadosFiltros] = React.useState(null);    

    const [filtrospreguntas, setFiltrosPreguntas] = React.useState(null);

    //EFECTOS

    React.useEffect(() => {
        fetch('api/Data/GetFiltrosEncuestasEstadisticas')
            .then(response => response.json())
            .then(data => {
                setFiltros(data);
                setLoadingFiltros(false);
            }).catch(error => {

            });

    }, [loadingFiltros]);
  

    function getDataPage() {

        //Obtengo los datos
        let formulario = document.getElementById('formbusqueda');
        let formData = new FormData(formulario);
        //const data = new FormData(this.refs.form);

        setLoading(true);

        fetch('api/Data/GetEncuestasEstadisticas', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            setData(res);
            setLoading(false);

        }).catch(error => {
            setData(null);
            setLoading(false);
        });
    }

    const onChangeEncuesta = (valor) => {
        if (valor != null) {
            let nuevo = { ...filtros }
            nuevo.tipobusqueda = valor;
            setFiltros(nuevo);
        }
    }

    const onChangeTipo = (valor) =>
    {
        if (valor != null)
        {
            let nuevo = { ...filtros }
            nuevo.tipobusqueda = valor;
            setFiltros(nuevo);
        }
    }

    const OnBuscarClick = () =>
    {
        getDataPage();
    }

    const OnBuscarSegunFiltrosRespuestasClick = () => {

        let formulario = document.getElementById('formbusqueda');
        let formData = new FormData(formulario);
        var object = {};
        formData.forEach((value, key) => { object[key] = value });

        //Obtengo los datos
        let formulariofiltros = document.getElementById('formbusquedaquestions');
        let formDatafiltros = new FormData(formulariofiltros);

        var objectfitros = [];
        formDatafiltros.forEach((value, key) => objectfitros.push({ id_question: key, valor: value }));

        object.filtros = objectfitros;

        setFiltrosPreguntas(objectfitros);

        var jsonData = JSON.stringify(object);

        fetch('api/Data/GetEncuestasEstadisticasFiltradas', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {
            setResultadosFiltros(res);

        }).catch(error => {

        });        
    }    

    function renderParametrosBusqueda() {

        return (<Grid container>
            <Grid item xs={12} sm={12} md={12}>
                <OthelloTituloPanelData margentop={1} margentop={1}>
                    <div>
                        <form id="formbusqueda" >   
                            <Grid container mb={1}>
                                <Grid item xs={3} sm={2} md={2} lg={1} mt={1}>
                                <Button color='info' size="sm" onClick={OnBuscarClick}>Buscar</Button>
                            </Grid>
                            <Grid item xs={5} sm={5} md={4} lg={3}>
                                <OthelloComboBox label='Encuesta' fieldname="id_encuesta" items={!loadingFiltros ? filtros.encuestas : []} onChange={onChangeEncuesta}  currentvalue={!loadingFiltros ? filtros.id_encuestadefault : 0}/>
                            </Grid>
                            <Grid item xs={4} sm={4} md={4} lg={2}>
                                    <OthelloComboBox label='Periodo' fieldname="tipobusqueda" items={TiposBusquedaEstadisticas} onChange={onChangeTipo} currentvalue={!loadingFiltros ? filtros.tipobusqueda :0} />                                                        
                            </Grid>
                            {filtros != null && filtros.tipobusqueda == TipoBusquedaEstadisticas.Personalizado ?
                                        <>
                                            <Grid item xs={6} sm={3} md={3} lg={2}>
                                                <OthelloTimer label="Desde" fieldname="desde" />
                                            </Grid>
                                            <Grid item xs={6} sm={3} md={3} lg={2}>
                                                <OthelloTimer label="Hasta" fieldname="hasta" />
                                            </Grid>
                                        </>: ""
                            }
                            </Grid>
                        </form>
                    </div>
                </OthelloTituloPanelData>
            </Grid>
        </Grid>)
    }


    function renderCombosPreguntas() {

        if (data.preguntas != null && data.preguntas.length > 0) {

            let res = data.preguntas.map((y, index) =>
            {
                if (y.tipo == TipoPreguntaEncuenta.TextoLibre)
                    return "";
                else {
                    let array = [];

                    array.push({ valor: "-1", name: "Todos" });

                    if (y.tipo == TipoPreguntaEncuenta.Combo || TipoPreguntaEncuenta.PreSelecOpcion || y.tipo == TipoPreguntaEncuenta.Provincias || y.tipo == TipoPreguntaEncuenta.Paises) {
                        if (y.resultados != null && y.resultados.length > 0)
                            y.resultados.forEach(x => {
                                if (x.resultexto != null)
                                    array.push({ valor: x.resultexto, name: x.resultexto })
                            });
                    }
                    else {
                        let arrayIni = [];

                        if (y.tipo == TipoPreguntaEncuenta.ComboUnoDiez)
                            arrayIni = OpcionComboUnoDiezEncuesta;
                        else if (y.tipo == TipoPreguntaEncuenta.ComboBienMalRegular)
                            arrayIni = OpcionComboBienMalRegularEncuesta;
                        else if (y.tipo == TipoPreguntaEncuenta.Estrellas)
                            arrayIni = OpcionEstrellasEncuesta;
                        else if (y.tipo == TipoPreguntaEncuenta.SiNo)
                            arrayIni = OpcionSiNoEncuesta;

                        array = arrayIni.filter(x => y.resultados.some(z => z.puntuacion == x.valor));                        
                        array.push({ valor: "-1", name: "Todos" });
                    }


                    let dataquestion = filtrospreguntas != null && filtrospreguntas.length > 0 ? filtrospreguntas.find(x => x.id_question == y.id_Question) : null;

                    return <Grid item><OthelloComboBox xs={12} sm={6} md={3} lg={2} label={y.pregunta} fieldname={y.id_Question} items={array} currentvalue={dataquestion != null ? dataquestion.valor : "-1"} />   </Grid> 
                }                             
            });

            return <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <OthelloTituloPanelData mt={2}>
                        <div>
                            <OthelloTitulo titulo={"Filtra los resultados de las encuestas realizadas " + data.desde + " - " + data.hasta} />
                            <form id="formbusquedaquestions" >   
                            {res}          
                            <br/>
                                <Grid container m={2}>
                                <Grid item xs={3} sm={2} md={2} lg={1}>
                                        <Button color='info' size="sm" onClick={OnBuscarSegunFiltrosRespuestasClick}>Obtener Resultados</Button>
                                </Grid>
                                </Grid>
                            </form>
                        </div>
                    </OthelloTituloPanelData>
                </Grid>
            </Grid>
        }
        else
            return "";
    }

    function renderFiltroPreguntasInfoEstadistica() {
        return !loading && data != null ? renderCombosPreguntas() : "";
    }

    function renderInfoEstadisticas() {

        return (
            !loading && resultadosFiltros != null ?
                <>
                    <Grid container mt={2 }>
                        <Grid item xs={12} sm={12} md={6}>
                            <OthelloCard color="success" categoria="Encuentas" titulo={resultadosFiltros.totalEncuestas} icono="receipt" footer="Encuestas realizas en el periodo" iconofooter="info" />
                        </Grid>                                            
                        <Grid item xs={12} sm={12} md={6}>
                            <OthelloTituloPanelData margentop={4}>
                                <div>
                                    Se han encontrado <b>{resultadosFiltros.totalCumplenFiltros}</b> encuenta/s que cumplen con los filtros indicados.                                 
                                </div>
                            </OthelloTituloPanelData>
                        </Grid>
                    </Grid>
                </>
                : "");
    }

    let paramsbsuqueda = renderParametrosBusqueda();

    let filtroestadisticas = renderFiltroPreguntasInfoEstadistica();

    let infoEstadisticas = renderInfoEstadisticas();



    return (<>
        {paramsbsuqueda}
        {filtroestadisticas}       
        {infoEstadisticas}
    </>);
}


EncuestasEstadisticaFiltradas.propTypes = {


}